module.exports = __webpack_public_path__ + "img/list3.95d88b5f.png";